import React from 'react'
import './loading.css'
import { Spinner, Overlay } from '@blueprintjs/core'

const Loading = () => {
  return (
    <Overlay isOpen className='loading-container'>
      <Spinner size={50} className='loading' />
    </Overlay>
  )
}

export default Loading
